import(/* webpackMode: "eager", webpackExports: ["RequestScopedProviders"] */ "/app/app/[locale]/providers/RequestScopedProviders.tsx");
